import React, { useEffect } from 'react';
import styles from '../components/styles/common.module.css';
import ImageBoard from '../components/individual/about_componey/ImageBoard';
import CorporateProfile from '../components/individual/about_componey/CorporateProfile';
import PageTitle from '../components/PageTitle';
import useScrollToHash from '../components/useScrollToHash'; // Adjust path based on your folder


const About = () => {

   useScrollToHash(); 

  return (
    <>
      <PageTitle 
        title="Company Profile" 
        description="Learn about DG FutureTech's mission, vision, and our commitment to providing exceptional IT services and solutions."
      />
      <div className={styles.AboutSection}>
        <div id="corporate-profile" style={{ scrollMarginTop: "50px" }}><CorporateProfile /></div>
        <div id="board-members" style={{ scrollMarginTop: "50px" }}><ImageBoard /></div>
      </div>
    </>
  );
};

export default About;
